/// <reference path="../../typings/browser.d.ts" />
/// <reference path="../../customtypings/window.d.ts" />

/**
 * Recordings/Exports service
 */
namespace Application.Services {
    'use strict';

    import IAllRecordingsExports = Models.IAllRecordingsExports; 
    import IRecordingsExports = Models.IRecordingsExports; 
    import IHalElement = Models.IHalElement;
    import IRunningTask = Models.IRunningTask;

    /**
     * Recordings/Exports service
     */
    export class RecordingsExportsService {
        public static $name: string = "recordingsExportsService";
        public static $inject: string[] = ['backendService'];

        
        private backendService: BackendService; 
        private backendBaseUrl: string = window.backendUrl;
        // private servicePath: string = 'flexocore/';
        private servicePath: string = 'mvpadapter/';
        private backendUrl: string = this.backendBaseUrl + this.servicePath + 'recordingsexports';

        constructor(backendService: BackendService) {
            this.backendService = backendService;
        }

        public getAllRecordingsExports(retry: boolean): ng.IPromise<IAllRecordingsExports> {
            return this.backendService
                .get(this.backendUrl + "/", retry)
                .then((result: ng.IHttpPromiseCallbackArg<IAllRecordingsExports>) => {
                    return result.data;
                });
        }

        public getRunningTasks(retry: boolean): ng.IPromise<IRunningTask[]> {
            return this.backendService
                .get(this.backendUrl + "/runningTasks", retry)
                    .then((result: ng.IHttpPromiseCallbackArg<IRunningTask[]>) => {
                        return result.data;
                    });
        }

        public getRecordingsExportsByClientHref(clientHref: string): ng.IPromise<IRecordingsExports> {
            return this.backendService
                .get(this.backendUrl + "/" + clientHref)
                .then((result: ng.IHttpPromiseCallbackArg<IRecordingsExports>) => {
                    return result.data;
                });
        }

        public createServerExport(serverHref: string, resource: string, start: number, format: string,
                                  end: number, description: string): ng.IPromise<{}> {
            return this.backendService
                .post(this.backendUrl + "/server/export", {
                    serverHref: serverHref,
                    rpcRequest: {
                        params: {
                            resource: resource,
                            start: start,
                            end: end,
                            format: format,
                            callback: "http://localhost/",
                            description: description,
                        },
                    },
                });
        }

        public createClientExport(serverHref: string, sessionid: string, startseq: number, endseq: number,
                                  clientid: string, resourcename: string, description: string): ng.IPromise<{}> {
            return this.backendService
                .post(this.backendUrl + "/client/export", {
                    serverHref: serverHref,
                    getRequest: {
                        sessionid: sessionid,
                        startseq: startseq,
                        endseq: endseq,
                        clientid: clientid,
                        resourcename: resourcename,
                        description: description,
                    },
                });
        }

        public deleteServerExport(serverHref: string, start: number, end: number,
                                  resource: string, description: string): ng.IPromise<{}> {
            return this.backendService
                .put(this.backendUrl + "/server/export/delete", {
                    serverHref: serverHref,
                    rpcRequest: {
                        params: {
                            resource: resource,
                            start: start,
                            end: end,
                            description: description,
                        },
                    },
                });
        }

        public deleteClientExport(serverHref: string, sessionid: string, start: number, end: number,
                                  resource: string, description: string): ng.IPromise<void> {
            return this.backendService
                .put(this.backendUrl + "/client/export/delete", {
                    serverHref: serverHref,
                    rpcRequest: {
                        params: {
                            sessionid: sessionid,
                            resource: resource,
                            start: start,
                            end: end,
                            description: description,
                        },
                    },
                })
                .then((result: ng.IHttpPromiseCallbackArg<IHalElement<IRecordingsExports>>) => {
                    Common.Utils.alertOnSuccess("Successfully deleted!");
                });
        }

        public transcodeClientExport(serverHref: string, sessionid: string, start: number, end: number,
                                     resource: string, resolution: string, exportfile: string): ng.IPromise<void> {
            return this.backendService
                .post(this.backendUrl + "/client/transcode", {
                    serverHref: serverHref,
                    rpcRequest: {
                        params: {
                            sessionid: sessionid,
                            resource: resource,
                            start: start,
                            end: end,
                            resolution: resolution,
                            exportfile: exportfile,
                        },
                    },
                })
                .then((result: ng.IHttpPromiseCallbackArg<IHalElement<IRecordingsExports>>) => {
                    Common.Utils.alertOnSuccess("Transcoding requested!");
                });
        }

        public transcodeServerExport(serverHref: string, resource: string, resolution: string, exportfile: string): ng.IPromise<{}> {
            return this.backendService
                .post(this.backendUrl + "/server/transcode", {
                    serverHref: serverHref,
                    rpcRequest: {
                        params: {
                            resource: resource,
                            resolution: resolution,
                            exportfile: exportfile,
                        },
                    },
                });
        }
    }
}